import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import {
  faYoutube,
  faFacebookF,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import "./footer.css";

function Footer() {
  return (
    <section className="footer">
      <div className="container">
        <div className="row footer_wrap text-center text-md-start">
          {/* Address Section */}
          <div className="col-12 col-md-6 col-lg-4 mb-4">
            <img
              className="img-fluid mb-3"
              src="/images/img_home_fresh.webp"
              alt="meme_home"
              style={{ maxWidth: "150px" }}
            />
            <p className="text-primary text-center fw-bold">
              CÔNG TY CỔ PHẦN THƯƠNG MẠI DỊCH VỤ WMA
            </p>
            <p className="fst-italic text-muted">
              MST: 0109452004 do Sở Kế hoạch và Đầu tư thành phố Hà Nội cấp ngày
              15/12/2020
            </p>
            <p className="fst-italic text-muted">
              Địa chỉ: Shop house TT04-24, Dự án Hải Đăng City, Phường Mỹ Đình
              2, Quận Nam Từ Liêm, Thành Phố Hà Nội, Việt Nam
            </p>
          </div>

          {/* Policies Section */}
          <div className="col-12 col-md-6 col-lg-2 mb-4">
            <p className="footer_category fw-bold">ĐIỀU KHOẢN VÀ CHÍNH SÁCH</p>

            <p className="text-primary">
              <Link to="/payment" className="text-decoration-none">
                Chính sách thanh toán
              </Link>
            </p>
            <p className="text-primary">
              <Link to="/security" className="text-decoration-none">
                Chính sách bảo mật
              </Link>
            </p>
            <p className="text-primary">
              <Link to="/service" className="text-decoration-none">
                Điều khoản dịch vụ
              </Link>
            </p>
            <p className="text-primary">Chính sách khách hàng thân thiết</p>
          </div>

          {/* Navigation Section */}
          <div className="col-12 col-md-6 col-lg-2 mb-4">
            <p className="footer_category fw-bold">MENU</p>
            <p>
              <Link to="/" className="text-decoration-none">
                Trang chủ
              </Link>
            </p>
            <p>
              <Link to="/products" className="text-decoration-none">
                Sản phẩm
              </Link>
            </p>
            <p>
              <Link to="/promotion" className="text-decoration-none">
                Khuyến mại
              </Link>
            </p>
            <p>
              <Link to="/about" className="text-decoration-none">
                Giới thiệu
              </Link>
            </p>
          </div>

          {/* Customer Care Section */}
          <div className="col-12 col-md-6 col-lg-2 mb-4">
            <p className="footer_category fw-bold">CHĂM SÓC KHÁCH HÀNG</p>
            <p className="text-info fst-italic fw-bold">0916.23.86.23</p>
            <p className="fst-italic text-success">THEO DÕI CHÚNG TÔI</p>
            <div className="d-flex justify-content-center gap-2">
              <a
                href="https://www.facebook.com/bim.memevietnam/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  className="footer_icon text-primary"
                  icon={faFacebookF}
                  mask={faCircle}
                  transform="shrink-7"
                />
              </a>
              <a
                href="https://www.youtube.com/channel/UCdtNRLAAYIKPlUUUIfRcs9w"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  className="footer_icon text-danger"
                  icon={faYoutube}
                />
              </a>
              <a
                href="https://www.tiktok.com/@memevietnam.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  className="footer_icon text-dark"
                  icon={faTiktok}
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mt-4">
        <a
          href="http://online.gov.vn/Home/WebDetails/135125"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="img-fluid"
            src="/images/logo_bct.webp"
            alt="bct_logo"
            style={{ maxWidth: "150px" }}
          />
        </a>
      </div>
    </section>
  );
}

export default Footer;
